import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faTimes } from "@fortawesome/free-solid-svg-icons";

// Lesson Detail Panel Component
const LessonDetailPanel = ({ lesson, onClose, onSave, onDelete, onEdit }) => {
  return (
    <div style={{ height: "100%" }}>
      {/* Header */}
      <div
        style={{
          padding: "24px 24px 16px 24px",
          borderBottom: "1px solid #f0f0f0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <div style={{ flex: 1 }}>
          <div className="d-flex align-items-center mb-2">
            <span
              style={{
                backgroundColor: "#F0D6B5",
                color: "#635956",
                padding: "4px 8px",
                borderRadius: "6px",
                fontSize: "12px",
                fontWeight: "600",
                marginRight: "12px",
              }}
            >
              Lesson {lesson.lesson_number}
            </span>
            <span
              style={{
                backgroundColor: "#e9ecef",
                color: "#495057",
                padding: "4px 8px",
                borderRadius: "6px",
                fontSize: "12px",
                fontWeight: "500",
              }}
            >
              {lesson.subject}
            </span>
          </div>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "8px",
              fontWeight: "700",
              lineHeight: "1.3",
            }}
          >
            {lesson.name}
          </h4>
        </div>
        <Button
          variant="outline-light"
          size="sm"
          onClick={onClose}
          style={{
            border: "none",
            color: "#6c757d",
            padding: "8px",
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </div>

      {/* Content */}
      <div style={{ padding: "24px", paddingBottom: "100px" }}>
        {/* AI Lesson Summary */}
        {lesson.lesson_maxim && (
          <div className="mb-4">
            <h6
              style={{
                color: "#495057",
                fontWeight: "600",
                marginBottom: "12px",
                fontSize: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              AI Lesson Summary
            </h6>
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "16px",
                borderRadius: "12px",
                border: "1px solid #e9ecef",
              }}
            >
              <p
                style={{
                  color: "#2c3e50",
                  lineHeight: "1.6",
                  marginBottom: "0",
                  fontSize: "15px",
                }}
              >
                {lesson.lesson_maxim}
              </p>
            </div>
          </div>
        )}

        {/* Intro Line */}
        {lesson.intro_line && (
          <div className="mb-4">
            <h6
              style={{
                color: "#495057",
                fontWeight: "600",
                marginBottom: "12px",
                fontSize: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Intro Line
            </h6>
            <p
              style={{
                color: "#2c3e50",
                lineHeight: "1.6",
                marginBottom: "0",
                fontSize: "15px",
                fontStyle: "italic",
              }}
            >
              {lesson.intro_line}
            </p>
          </div>
        )}

        {/* Summary */}
        {lesson.summary && (
          <div className="mb-4">
            <h6
              style={{
                color: "#495057",
                fontWeight: "600",
                marginBottom: "12px",
                fontSize: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Summary
            </h6>
            <p
              style={{
                color: "#2c3e50",
                lineHeight: "1.6",
                marginBottom: "0",
                fontSize: "15px",
              }}
            >
              {lesson.summary}
            </p>
          </div>
        )}

        {/* The Science */}
        {lesson.science && (
          <div className="mb-4">
            <h6
              style={{
                color: "#495057",
                fontWeight: "600",
                marginBottom: "12px",
                fontSize: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              The Science
            </h6>
            <p
              style={{
                color: "#2c3e50",
                lineHeight: "1.6",
                marginBottom: "0",
                fontSize: "15px",
              }}
            >
              {lesson.science}
            </p>
          </div>
        )}

        {/* Today's Task */}
        {lesson.task && (
          <div className="mb-4">
            <h6
              style={{
                color: "#495057",
                fontWeight: "600",
                marginBottom: "12px",
                fontSize: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Today's Task
            </h6>
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "16px",
                borderRadius: "12px",
                border: "1px solid #e9ecef",
              }}
            >
              <p
                style={{
                  color: "#2c3e50",
                  lineHeight: "1.6",
                  marginBottom: "0",
                  fontSize: "15px",
                }}
              >
                {lesson.task}
              </p>
            </div>
          </div>
        )}

        {/* AI Prompts */}
        {lesson.suggested_questions &&
          lesson.suggested_questions.length > 0 && (
            <div className="mb-4">
              <h6
                style={{
                  color: "#495057",
                  fontWeight: "600",
                  marginBottom: "12px",
                  fontSize: "14px",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                AI Prompts ({lesson.suggested_questions.length})
              </h6>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                {lesson.suggested_questions.map((question, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: "#fff",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      border: "1px solid #e9ecef",
                      fontSize: "14px",
                      color: "#2c3e50",
                    }}
                  >
                    {question}
                  </div>
                ))}
              </div>
            </div>
          )}

        {/* Image */}
        {lesson.image && (
          <div className="mb-4">
            <h6
              style={{
                color: "#495057",
                fontWeight: "600",
                marginBottom: "12px",
                fontSize: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Image URL
            </h6>
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #e9ecef",
                fontFamily: "monospace",
                fontSize: "13px",
                color: "#6c757d",
                wordBreak: "break-all",
              }}
            >
              {lesson.image}
            </div>
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div
        style={{
          position: "absolute",
          bottom: "0",
          left: "0",
          right: "0",
          padding: "24px",
          backgroundColor: "#fff",
          borderTop: "1px solid #f0f0f0",
          borderBottomLeftRadius: "16px",
          borderBottomRightRadius: "16px",
        }}
      >
        <div className="d-flex gap-2">
          <Button
            onClick={() => onEdit(lesson)}
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              color: "white",
              fontWeight: "600",
              flex: 1,
              padding: "12px",
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="me-2" />
            Edit
          </Button>
          <Button
            variant="outline-danger"
            onClick={() => onDelete(lesson.id)}
            style={{
              fontWeight: "600",
              padding: "12px",
            }}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LessonDetailPanel;
